import React, { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { PageHeader, Badge, statusTone, EmptyState } from "@/components/common";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { UserPlus, Download } from "lucide-react";

export default function AdminLeads() {
  const [leads, setLeads] = useState([]);
  const [role, setRole] = useState("all");
  const load = useCallback(() => api.get(`/leads?role=${role === "all" ? "" : role}`).then(({ data }) => setLeads(data)), [role]);
  useEffect(() => { load(); }, [load]);

  const exportCsv = () => {
    const rows = [["Name", "Email", "Mobile", "Role", "Source", "Status", "Date"], ...leads.map((l) => [l.name, l.email, l.mobile, l.role, l.source, l.status, l.created_at])];
    const csv = rows.map((r) => r.map((c) => `"${c || ""}"`).join(",")).join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const a = document.createElement("a"); a.href = URL.createObjectURL(blob); a.download = "leads.csv"; a.click();
  };

  return (
    <div data-testid="admin-leads">
      <PageHeader title="Leads Management" subtitle={`${leads.length} leads captured`} action={<Button variant="outline" onClick={exportCsv} data-testid="export-leads"><Download size={15} className="mr-1" /> Export CSV</Button>} />
      <div className="mb-6"><Select value={role} onValueChange={setRole}><SelectTrigger className="w-44" data-testid="lead-role-filter"><SelectValue /></SelectTrigger><SelectContent><SelectItem value="all">All Roles</SelectItem><SelectItem value="learner">Learners</SelectItem><SelectItem value="educator">Educators</SelectItem><SelectItem value="content_seller">Sellers</SelectItem></SelectContent></Select></div>
      {leads.length === 0 ? <EmptyState icon={UserPlus} title="No leads" /> : (
        <div className="bg-white border border-border rounded-lg overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-muted text-left text-muted-foreground"><tr><th className="p-4">Name</th><th className="p-4">Email</th><th className="p-4">Mobile</th><th className="p-4">Role</th><th className="p-4">Source</th><th className="p-4">Status</th></tr></thead>
            <tbody>{leads.map((l) => (
              <tr key={l.id} className="border-t border-border" data-testid={`lead-${l.id}`}>
                <td className="p-4 font-medium text-navy">{l.name}</td><td className="p-4 text-muted-foreground">{l.email}</td><td className="p-4">{l.mobile || "-"}</td>
                <td className="p-4"><Badge tone="gray">{l.role?.replace("_", " ")}</Badge></td><td className="p-4 capitalize">{l.source}</td><td className="p-4"><Badge tone={statusTone(l.status)}>{l.status}</Badge></td>
              </tr>
            ))}</tbody>
          </table>
        </div>
      )}
    </div>
  );
}
